import { render } from "./TemplateManagerLite.vue?vue&type=template&id=aa9cc188"
import script from "./TemplateManagerLite.vue?vue&type=script&lang=js"
export * from "./TemplateManagerLite.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__